/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-15 00:07:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 00:08:22
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/ProductSelectionWithHsCode/HsCode/hooks.ts
 */
import React from 'react';

const useHsPreload = (hsCodes, setHsCodes, fetch) => {
  const getDefaultOptions = () => {
    fetch(0, 50, { hsCodePrefix: '1' }).then((codes) => {
      const { results } = codes;
      setHsCodes(results);
    });
  };

  const handleOnHsCodeDropdownChange = (open) => {
    if (!open && hsCodes.length === 0) {
      getDefaultOptions();
    }
  };

  React.useEffect(() => {
    getDefaultOptions();
  }, []); //preload
  return { handleOnHsCodeDropdownChange };
};
export { useHsPreload };
